export default {
  create_title: 'New Partner API account',
  edit_title: 'Edit account',
  form: {
    name: 'Account name',
    name_placeholder: 'e.g. Acme POS integration',
    contact_email: 'Contact email',
    scope: 'Restaurant access',
    companies: 'Restaurants',
    scope_selected: 'Selected restaurants',
    scope_all: 'All restaurants',
    scope_all_help:
      'Keys on this account reach every restaurant of your organisation, including ones registered later.',
    companies_placeholder: 'Select restaurants',
    companies_help: 'Keys issued on this account can read and write only these restaurants.',
    is_active: 'Active',
    is_active_help: 'Inactive accounts are rejected at authentication.',
  },
  buttons: {
    cancel: 'Cancel',
    save: 'Save',
    create: 'Create',
  },
  toasts: {
    created: 'Partner API account created.',
    updated: 'Account updated.',
    error: 'Could not save the account.',
  },
};
